(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const valuesMatch = (first, second) => String(first || '')
      .localeCompare(String(second || ''), undefined, { sensitivity: 'base' }) === 0;

    const sortValues = (values) => {
      const uniqueValues = new Map();
      values.filter(Boolean).forEach((value) => {
        const key = value.toLocaleLowerCase();
        if (!uniqueValues.has(key)) uniqueValues.set(key, value);
      });
      return [...uniqueValues.values()]
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true }));
    };

    const addOptions = (select, values) => {
      const placeholder = select.options[0];
      select.replaceChildren(placeholder);
      sortValues(values).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.append(option);
      });
      select.disabled = select.options.length < 2;
    };

    const loadAllProductPages = async (root, initialData) => {
      const currentPage = Number(initialData.dataset.currentPage || 1);
      const totalPages = Number(initialData.dataset.totalPages || 1);
      const pageParam = initialData.dataset.pageParam || 'page';
      const products = JSON.parse(initialData.textContent);

      if (totalPages < 2) return products;

      const requests = [];
      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set(pageParam, String(page));
        requests.push(
          fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then((response) => {
              if (!response.ok) throw new Error(`Vehicle finder request failed: ${response.status}`);
              return response.text();
            })
            .then((html) => {
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const pageData = documentFragment.querySelector('[data-vehicle-products]');
              return pageData ? JSON.parse(pageData.textContent) : [];
            })
        );
      }

      const remainingPages = await Promise.all(requests);
      return products.concat(...remainingPages);
    };

    const normalizeProducts = (products) => products.map((product) => ({
      ...product,
      fitments: Array.isArray(product.fitments)
        ? product.fitments
          .map((fitment) => ({
            make: String(fitment.make || '').trim(),
            model: String(fitment.model || '').trim(),
            subModel: String(fitment.sub_model || '').trim()
          }))
          .filter((fitment) => fitment.make && fitment.model && fitment.subModel)
        : []
    }));

    const initializeFinder = async (root) => {
      if (root.dataset.initialized === 'true') return;

      const data = root.querySelector('[data-vehicle-products]');
      const form = root.querySelector('[data-vehicle-form]');
      if (!data || !form) return;

      root.dataset.initialized = 'true';
      const manufacturer = root.querySelector('[data-vehicle-manufacturer]');
      const model = root.querySelector('[data-vehicle-model]');
      const subModel = root.querySelector('[data-vehicle-sub-model]');
      const submit = root.querySelector('[data-vehicle-submit]');
      const results = root.querySelector('[data-vehicle-results]');
      const status = root.querySelector('[data-vehicle-status]');
      const template = root.querySelector('[data-vehicle-card-template]');
      manufacturer.disabled = true;

      let products;
      try {
        products = normalizeProducts(await loadAllProductPages(root, data));
      } catch (error) {
        products = normalizeProducts(JSON.parse(data.textContent));
      }

      const updateSubmit = () => {
        submit.disabled = !(manufacturer.value && model.value && subModel.value);
      };

      addOptions(
        manufacturer,
        products.flatMap((product) => product.fitments.map((fitment) => fitment.make))
      );

      manufacturer.addEventListener('change', () => {
        addOptions(
          model,
          products
            .flatMap((product) => product.fitments)
            .filter((fitment) => valuesMatch(fitment.make, manufacturer.value))
            .map((fitment) => fitment.model)
        );
        addOptions(subModel, []);
        updateSubmit();
      });

      model.addEventListener('change', () => {
        addOptions(
          subModel,
          products
            .flatMap((product) => product.fitments)
            .filter((fitment) => (
              valuesMatch(fitment.make, manufacturer.value) &&
              valuesMatch(fitment.model, model.value)
            ))
            .map((fitment) => fitment.subModel)
        );
        updateSubmit();
      });

      subModel.addEventListener('change', updateSubmit);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const matches = products.filter((product) => product.fitments.some((fitment) => (
          valuesMatch(fitment.make, manufacturer.value) &&
          valuesMatch(fitment.model, model.value) &&
          valuesMatch(fitment.subModel, subModel.value)
        )));

        results.replaceChildren();
        matches.forEach((product) => {
          const card = template.content.cloneNode(true);
          const link = card.querySelector('[data-card-link]');
          const imageWrap = card.querySelector('[data-card-image-wrap]');
          const image = card.querySelector('[data-card-image]');
          link.href = product.url;
          card.querySelector('[data-card-title]').textContent = product.title;
          card.querySelector('[data-card-price]').textContent = product.price;

          if (product.image) {
            image.src = product.image;
            image.alt = product.imageAlt;
          } else {
            imageWrap.remove();
          }

          if (!product.available) {
            card.querySelector('[data-card-sold-out]').hidden = false;
          }

          results.append(card);
        });

        status.textContent = matches.length === 1
          ? root.dataset.resultSingular.replace('[count]', matches.length)
          : root.dataset.resultPlural.replace('[count]', matches.length);
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-vehicle-finder]').forEach(initializeFinder);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
